import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import { getDetailedHistory, addCaseNote } from "requests/homeowner/caseforms";
import { MTable, MSpinner } from "components/Shared";
import { formatNoteDateCreated, getHistoryTypeDiv, getNoteDetails } from "components/Homeowner/History/DataFormatters";
import NoteInputField, { NOTE_EXTERNAL } from "components/Shared/NoteInputField";
import { CASE_NOTE_TYPE_GENERAL } from "typeConstants/caseNoteTypes";

const CompactHistory = (props) => {
  const [history, setHistory] = useState();

  let mounted = useRef(true);

  useEffect(() => {
    getHistory();
    return () => {
      mounted.current = false;
    };
  }, []);

  const getHistory = () => {
    getDetailedHistory(props.controlNumber, setHistory, mounted);
  };

  const saveNote = (noteText, noteType) => {
    let payload = {
      noteBody: noteText,
      isExternal: noteType === NOTE_EXTERNAL ? true : false
    };
    addCaseNote(props.controlNumber, CASE_NOTE_TYPE_GENERAL, payload, getHistory, mounted);
  };

  const getNoteRow = (note, index) => {
    return (
      <React.Fragment key={`note-${index}`}>
        <div className="note-row-top">
          <div>{formatNoteDateCreated(note)}</div>
          <div>{getHistoryTypeDiv(note)}</div>
          <div>{note.performedBy}</div>
        </div>
        <div className="note-row-bottom">
          {getNoteDetails(note)}
        </div>
      </React.Fragment>);
  };

  return history ? (
    <div className="compact-history">
      {props.viewInternalNotesInput && 
        <NoteInputField 
            saveNote={saveNote}
            placeholder="Add Note. Select “External” if you wish to allow the customer to see this note."
            showNoteType
          />}
      <MTable
        renderEmptyTable
        className="tabbed-history"
        columnDefinitions={[
          { name: "Date", style: { width: "180px", minWidth: "180px" } },
          { name: "Type", style: { width: "50px", minWidth: "50px" } },
          { name: "Performed By", dataSource: "performedBy" },
        ]}
      />
      <div className="table-content">
        {history && history.all.map((n, i) => getNoteRow(n, i))}
      </div>
    </div>
  ) : <MSpinner />;
};

CompactHistory.propTypes = {
  controlNumber: PropTypes.number,
  viewInternalNotesInput: PropTypes.bool,
};

export default CompactHistory;
